
export enum SeriesStateEnum {
    none,
    loading,
    loaded,
    error
}
